import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminProfile } from "@/pages/admin/profile";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/admin/profile/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<AdminProfile />
		</DashboardLayout>
	);
}
